/**
 * Trigger kind of a level transition (DunningTypeLevelTransition): whether the
 * transition fires automatically (system-driven) or is triggered manually.
 *
 * Mirrors backend enum {@code com.mvs.backend.bd.enums.BdDunningTransitionType}.
 * Ordinal mapping (MUST match the backend enum):
 *   0 = AUTOMATIC
 *   1 = MANUAL
 *
 * @ticket bd-dunningtype-overview
 */
export enum BdDunningTransitionType {
    AUTOMATIC,
    MANUAL
}

/**
 * German UI labels for BdDunningTransitionType values.
 */
export const BD_DUNNING_TRANSITION_TYPE_LABELS: Record<BdDunningTransitionType, string> = {
    [BdDunningTransitionType.AUTOMATIC]: 'Automatisch',
    [BdDunningTransitionType.MANUAL]: 'Manuell'
};
